

define(function (require, exports, module) {

	'use strict';

	module.exports = function () {


		let dataURIToBlob = function (dataURI, mimeType) {

			let binStr = atob(dataURI.split(',')[1]),
				len = binStr.length,
				arr = new Uint8Array(len),
				mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

			for (let i = 0; i < len; i++) {
				arr[i] = binStr.charCodeAt(i);
			}

			if (window.navigator.userAgent.indexOf("Safari") > -1) {
				mimeString = mimeType;
			}

			return new Blob([arr], {
				type: mimeString
			});

		}

		let downloadBlob = function (response, fileName, mimeType) {

			let linkElement = document.createElement('a');
			let dataURI = "data:application/octet-stream;base64," + response;
			let blob = dataURIToBlob(dataURI, mimeType);
			let url = URL.createObjectURL(blob);
			linkElement.download = fileName;
			linkElement.href = url;
			linkElement.onclick = function () {
				requestAnimationFrame(function () {
					URL.revokeObjectURL(url);
				})
			};

			let clickEvent = new MouseEvent("click", {
				"view": window,
				"bubbles": true,
				"cancelable": false
			});
			linkElement.dispatchEvent(clickEvent);
		}

		let downloadFile = {

			pdfForMobile: function (response) {
				let jsonObject = {
					"fileInfo": {
						"fileName": response.fileName,
						"fileExtension": response.fileExtension,
						"fileData": response.fileData
					}
				};
				gadgets.pubsub.publish(lpConstants.PUBLISH.FILE_INFO, { 'relationship': 'Child', 'target': 'PdfView', "payload": jsonObject });
			},

			pdf: function (response) {
				let linkElement = document.createElement('a');
				let content = 'data:' + response.mimeType + ';base64,' + response.fileData;
				linkElement.setAttribute('href', content);
				linkElement.setAttribute('download', response.fileName);
				// IE workaround
				if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					let byteCharacters = atob(response.fileData);
					let byteNumbers = [];
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers.push(byteCharacters.charCodeAt(i));
					}
					let byteArray = new Uint8Array(byteNumbers);
					let blob = new Blob([byteArray], { type: response.mimeType });
					window.navigator.msSaveOrOpenBlob(blob, response.fileName);
				}
				else {
					downloadBlob(response.fileData, response.fileName, response.mimeType);
				}
			}
		};
		return downloadFile;

	};
});





//////////////////
// WEBPACK FOOTER
// ./scripts/lib/download-file.js
// module id = 8
// module chunks = 0